<div class="flex h-full w-full outline overflow-hidden">
  <app-demo-sidebar
    [isCollapsed]="isCollapsed()"
    (isCollapsedChange)="isCollapsed.set($event)"
    [sections]="sidebarSections"
    baseRoutePath="demo"
    [isDisabledFn]="isRouteDisabled"
    [activeRoutePath]="getActiveMockRoute().path"
    (toggleActiveRoute)="toggleActiveMockRoute()"
    (homeNavigate)="goHome()" />

  <div class="flex-1 overflow-auto p-(--padding-card)">
    <div class="mb-(--space-4) p-(--padding-card) bg-blue-50 rounded-md hidden">
      <h1 class="text-xl font-bold mb-(--space-2)">Démo Sidebar</h1>
      <p>
        Route active: <strong>{{ getActiveMockRoute().title }}</strong>
      </p>
      <div class="flex gap-(--gap-normal) mt-(--space-2)">
        <ces-button label="Toggle Sidebar" (onClick)="toggleSidebar()" icon="menu" />
        <ces-button-secondary label="Toggle Première Section" (onClick)="toggleSectionCollapse(0)" />
      </div>
    </div>

    <div class="flex items-start justify-start flex-col w-full gap-(--gap-relaxed)">
      <p-card header="Démo Sidebar">
        <div class="w-full flex flex-row gap-(--gap-relaxed)">
          <p-card subheader="Sections">
            <div class="flex flex-col gap-(--gap-normal)">
              @for (section of sidebarSections; track section.path; let i = $index) {
                <div class="mb-(--space-2)">
                  <h3 class="font-medium">{{ section.title }}</h3>
                  <p>Routes: {{ section.routes.length }}</p>
                  <p>État: {{ section.collapsed ? 'Replié' : 'Déplié' }}</p>
                  <ces-button size="small" label="Toggle Section" (onClick)="toggleSectionCollapse(i)" />
                </div>
              }
            </div>
          </p-card>

          <p-card subheader="Routes (work in progress)">
            <div class="flex flex-col gap-(--gap-normal)">
              <h3 class="font-medium">Routes actives et désactivées</h3>
              @for (section of sidebarSections; track section.path) {
                <div class="mb-(--space-2)">
                  <h4 class="text-sm font-medium text-(color:--text-secondary)">
                    {{ section.title }}
                  </h4>
                  <ul class="list-disc pl-(--space-5)">
                    @for (route of section.routes; track route.path) {
                      <li
                        [class.font-bold]="route.path === getActiveMockRoute().path"
                        [class.text-(color:--text-secondary)]="route.disabled">
                        {{ route.title }}
                        @if (route.path === getActiveMockRoute().path) {
                          <span class="text-green-600"> (Active) </span>
                        }
                        @if (route.disabled) {
                          <span class="text-(color:--text-secondary)"> (Désactivée) </span>
                        }
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          </p-card>
        </div>
      </p-card>

      <p-card header="Composant paramètres d'expression">
        <ces-parameters-input (parametersChange)="parameterValue = $event" />
        <pre>{{ parameterValue | json }}</pre>
      </p-card>

      <p-card header="Composant éditeur d'expression">
        <ces-editor
          class="w-full block outline"
          [initialValue]="expressionValue"
          (expressionChange)="expressionValue = $event"
          [variables]="expressionVariables" />
        <pre>{{ expressionValue | json }}</pre>
      </p-card>

      <p-card header="Icônes Material">
        <div class="w-full flex flex-row flex-wrap gap-(--gap-loose)">
          <p-card subheader="Tailles d'icônes">
            <div class="flex flex-row gap-(--gap-relaxed) items-end flex-wrap">
              <div class="flex flex-col items-center">
                <ces-icon size="xs">favorite</ces-icon>
                <span class="text-xs mt-(--space-1)">XS</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon size="sm">favorite</ces-icon>
                <span class="text-xs mt-(--space-1)">SM</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon size="md">favorite</ces-icon>
                <span class="text-xs mt-(--space-1)">MD</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon size="lg">favorite</ces-icon>
                <span class="text-xs mt-(--space-1)">LG</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon size="xl">favorite</ces-icon>
                <span class="text-xs mt-(--space-1)">XL</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon size="2xl">favorite</ces-icon>
                <span class="text-xs mt-(--space-1)">2XL</span>
              </div>
            </div>
          </p-card>

          <p-card subheader="Couleurs d'icônes">
            <div class="flex flex-row gap-(--gap-relaxed)">
              <div class="flex flex-col items-center">
                <ces-icon color="primary">circle</ces-icon>
                <span class="text-xs mt-(--space-1)">Primary</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon color="secondary">circle</ces-icon>
                <span class="text-xs mt-(--space-1)">Secondary</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon color="success">circle</ces-icon>
                <span class="text-xs mt-(--space-1)">Success</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon color="info">circle</ces-icon>
                <span class="text-xs mt-(--space-1)">Info</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon color="warning">circle</ces-icon>
                <span class="text-xs mt-(--space-1)">Warning</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon color="danger">circle</ces-icon>
                <span class="text-xs mt-(--space-1)">Danger</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon color="help">circle</ces-icon>
                <span class="text-xs mt-(--space-1)">Help</span>
              </div>
            </div>
          </p-card>

          <p-card subheader="Styles d'icônes">
            <div class="flex flex-row gap-(--gap-relaxed)">
              <div class="flex flex-col items-center">
                <ces-icon outlined="true">star</ces-icon>
                <span class="text-xs mt-(--space-1)">Outlined</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon outlined="false">star</ces-icon>
                <span class="text-xs mt-(--space-1)">Filled</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon rounded="true">star</ces-icon>
                <span class="text-xs mt-(--space-1)">Rounded</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon sharp="true">star</ces-icon>
                <span class="text-xs mt-(--space-1)">Sharp</span>
              </div>
            </div>
          </p-card>

          <p-card subheader="Variations fill/weight">
            <div class="flex flex-row gap-(--gap-loose)">
              <div>
                <h4 class="text-sm font-medium mb-(--space-2)">Fill (remplissage)</h4>
                <div class="flex flex-row gap-(--gap-relaxed)">
                  <div class="flex flex-col items-center">
                    <ces-icon fill="0">favorite</ces-icon>
                    <span class="text-xs mt-(--space-1)">0</span>
                  </div>
                  <div class="flex flex-col items-center">
                    <ces-icon fill="1">favorite</ces-icon>
                    <span class="text-xs mt-(--space-1)">1</span>
                  </div>
                </div>
              </div>

              <div>
                <h4 class="text-sm font-medium mb-(--space-2)">Weight (épaisseur)</h4>
                <div class="flex flex-row gap-(--gap-relaxed)">
                  <div class="flex flex-col items-center">
                    <ces-icon weight="100">star</ces-icon>
                    <span class="text-xs mt-(--space-1)">100</span>
                  </div>
                  <div class="flex flex-col items-center">
                    <ces-icon weight="400">star</ces-icon>
                    <span class="text-xs mt-(--space-1)">400</span>
                  </div>
                  <div class="flex flex-col items-center">
                    <ces-icon weight="700">star</ces-icon>
                    <span class="text-xs mt-(--space-1)">700</span>
                  </div>
                </div>
              </div>
            </div>
          </p-card>

          <p-card subheader="Rotation et retournement">
            <div class="flex flex-row flex-wrap gap-(--gap-loose)">
              <div>
                <h4 class="text-sm font-medium mb-(--space-2)">Rotation</h4>
                <div class="flex flex-row gap-(--gap-relaxed)">
                  <div class="flex flex-col items-center">
                    <ces-icon rotate="0">arrow_forward</ces-icon>
                    <span class="text-xs mt-(--space-1)">0°</span>
                  </div>
                  <div class="flex flex-col items-center">
                    <ces-icon rotate="90">arrow_forward</ces-icon>
                    <span class="text-xs mt-(--space-1)">90°</span>
                  </div>
                  <div class="flex flex-col items-center">
                    <ces-icon rotate="180">arrow_forward</ces-icon>
                    <span class="text-xs mt-(--space-1)">180°</span>
                  </div>
                  <div class="flex flex-col items-center">
                    <ces-icon rotate="270">arrow_forward</ces-icon>
                    <span class="text-xs mt-(--space-1)">270°</span>
                  </div>
                </div>
              </div>

              <div>
                <h4 class="text-sm font-medium mb-(--space-2)">Retournement (flip)</h4>
                <div class="flex flex-row gap-(--gap-relaxed)">
                  <div class="flex flex-col items-center">
                    <ces-icon>thumb_up</ces-icon>
                    <span class="text-xs mt-(--space-1)">Normal</span>
                  </div>
                  <div class="flex flex-col items-center">
                    <ces-icon flip="horizontal">thumb_up</ces-icon>
                    <span class="text-xs mt-(--space-1)">Horizontal</span>
                  </div>
                  <div class="flex flex-col items-center">
                    <ces-icon flip="vertical">thumb_up</ces-icon>
                    <span class="text-xs mt-(--space-1)">Vertical</span>
                  </div>
                  <div class="flex flex-col items-center">
                    <ces-icon flip="both">thumb_up</ces-icon>
                    <span class="text-xs mt-(--space-1)">Both</span>
                  </div>
                </div>
              </div>
            </div>
          </p-card>

          <p-card subheader="Interactivité">
            <div class="flex flex-row gap-(--gap-loose)">
              <div class="flex flex-col gap-(--gap-normal)">
                <h4 class="text-sm font-medium">Icônes cliquables</h4>
                <div class="flex flex-row gap-(--gap-relaxed)">
                  <ces-icon clickable="true" color="primary" size="lg">add_circle</ces-icon>
                  <ces-icon clickable="true" color="danger" size="lg">delete</ces-icon>
                  <ces-icon clickable="true" color="info" size="lg">edit</ces-icon>
                </div>
              </div>

              <div class="flex flex-col gap-(--gap-normal)">
                <h4 class="text-sm font-medium">Icônes centrées</h4>
                <div
                  class="p-(--space-2) border border-(--border) rounded-(--radius-md) flex items-center justify-center"
                  style="width: 60px; height: 60px">
                  <ces-icon centered="true" color="primary" size="xl">info</ces-icon>
                </div>
              </div>
            </div>
          </p-card>

          <p-card subheader="Combinaisons et cas d'usage">
            <div class="flex flex-row gap-(--gap-loose) flex-wrap">
              <div class="flex flex-col gap-(--gap-relaxed)">
                <h4 class="text-sm font-medium">Notifications</h4>
                <div class="flex flex-row gap-(--gap-relaxed) flex-wrap">
                  <div class="p-(--space-3) bg-blue-50 rounded-(--radius-lg) flex items-center gap-(--gap-normal)">
                    <ces-icon color="info" size="lg">info</ces-icon>
                    <span>Information</span>
                  </div>
                  <div class="p-(--space-3) bg-yellow-50 rounded-(--radius-lg) flex items-center gap-(--gap-normal)">
                    <ces-icon color="warning" size="lg">warning</ces-icon>
                    <span>Avertissement</span>
                  </div>
                  <div class="p-(--space-3) bg-red-50 rounded-(--radius-lg) flex items-center gap-(--gap-normal)">
                    <ces-icon color="danger" size="lg">error</ces-icon>
                    <span>Erreur</span>
                  </div>
                </div>
              </div>

              <div class="flex flex-col gap-(--gap-relaxed)">
                <h4 class="text-sm font-medium">Boutons avec icônes</h4>
                <div class="flex flex-row gap-(--gap-relaxed) flex-wrap">
                  <button
                    class="flex items-center gap-(--gap-normal) p-(--space-2) bg-blue-500 text-white rounded-(--radius-md) hover:bg-blue-600">
                    <ces-icon>add</ces-icon>
                    <span>Ajouter</span>
                  </button>
                  <button
                    class="flex items-center gap-(--gap-normal) p-(--space-2) bg-green-500 text-white rounded-(--radius-md) hover:bg-green-600">
                    <ces-icon>check</ces-icon>
                    <span>Valider</span>
                  </button>
                  <button
                    class="flex items-center gap-(--gap-normal) p-(--space-2) border border-(--border) rounded-(--radius-md) hover:bg-(--surface-2)">
                    <ces-icon>search</ces-icon>
                    <span>Rechercher</span>
                  </button>
                </div>
              </div>
            </div>
          </p-card>

          <p-card subheader="Icônes communes">
            <div class="flex flex-row flex-wrap gap-(--gap-relaxed)">
              <div class="flex flex-col items-center">
                <ces-icon>home</ces-icon>
                <span class="text-xs mt-(--space-1)">home</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon>settings</ces-icon>
                <span class="text-xs mt-(--space-1)">settings</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon>person</ces-icon>
                <span class="text-xs mt-(--space-1)">person</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon>search</ces-icon>
                <span class="text-xs mt-(--space-1)">search</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon>notifications</ces-icon>
                <span class="text-xs mt-(--space-1)">notifications</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon>mail</ces-icon>
                <span class="text-xs mt-(--space-1)">mail</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon>cloud_upload</ces-icon>
                <span class="text-xs mt-(--space-1)">cloud_upload</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon>cloud_download</ces-icon>
                <span class="text-xs mt-(--space-1)">cloud_download</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon>calendar_today</ces-icon>
                <span class="text-xs mt-(--space-1)">calendar_today</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon>description</ces-icon>
                <span class="text-xs mt-(--space-1)">description</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon>dashboard</ces-icon>
                <span class="text-xs mt-(--space-1)">dashboard</span>
              </div>
              <div class="flex flex-col items-center">
                <ces-icon>folder</ces-icon>
                <span class="text-xs mt-(--space-1)">folder</span>
              </div>
            </div>
          </p-card>
        </div>
      </p-card>
      <div class="flex flex-col gap-(--gap-relaxed)">
        <h2>Menu buttons</h2>
        <div class="flex flex-col gap-(--gap-relaxed)">
          <div class="flex flex-row gap-(--gap-relaxed)">
            <ces-menu-button [items]="items" label="Ajouter" icon="add" />
            <ces-menu-button-secondary [items]="items" label="Ajouter" icon="add" />
          </div>
          <div class="flex flex-row gap-(--gap-relaxed)">
            <ces-menu-button [items]="items" label="Ajouter" icon="add" [disabled]="true" />
            <ces-menu-button-secondary [items]="items" label="Ajouter" icon="add" [disabled]="true" />
          </div>
          <div class="flex flex-row gap-(--gap-relaxed)">
            <ces-menu-button [items]="items" label="Ajouter" icon="add" size="small" />
            <ces-menu-button-secondary [items]="items" label="Ajouter" icon="add" size="small" />
          </div>
          <div class="flex flex-row gap-(--gap-relaxed)">
            <ces-menu-button [items]="items" label="Ajouter" icon="add" size="small" [disabled]="true" />
            <ces-menu-button-secondary [items]="items" label="Ajouter" icon="add" size="small" [disabled]="true" />
          </div>
        </div>
        <h2>Normal buttons</h2>
        <div
          class="flex flex-col gap-(--gap-relaxed) bg-(--surface-2) p-(--padding-card) border-3 border-violet-600 border-dashed rounded-(--radius-md)">
          <div class="flex flex-row gap-(--gap-relaxed)">
            <ces-button pTooltip="test" label="Ajouter" (onClick)="log('Ajouter')" />
            <ces-button-secondary label="Secondary" (onClick)="log('Secondary')" />
            <ces-button-tertiary label="tertiary" (onClick)="log('tertiary')" />
            <ces-button-tertiary-white label="tertiary white" (onClick)="log('tertiary white')" />
          </div>
          <div class="flex flex-row gap-(--gap-relaxed)">
            <ces-button [disabled]="true" label="Primary" (onClick)="log('Primary')" />
            <ces-button-secondary [disabled]="true" label="Secondary" (onClick)="log('Secondary')" />
            <ces-button-tertiary [disabled]="true" label="tertiary" (onClick)="log('tertiary')" />
            <ces-button-tertiary-white [disabled]="true" label="tertiary white" (onClick)="log('tertiary white')" />
          </div>
          <div class="flex flex-row gap-(--gap-relaxed)">
            <ces-button label="Ajouter" (onClick)="log('Ajouter')" size="small" />
            <ces-button-secondary label="Secondary" (onClick)="log('Secondary')" size="small" />
            <ces-button-tertiary label="tertiary" (onClick)="log('tertiary')" size="small" />
            <ces-button-tertiary-white label="tertiary white" (onClick)="log('tertiary white')" size="small" />
          </div>
        </div>
        <h2>With icons</h2>
        <div
          class="flex flex-col gap-(--gap-relaxed) bg-(--surface-2) p-(--padding-card) border-3 border-violet-600 border-dashed rounded-(--radius-md)">
          <h3 class="text-white">Left icons</h3>
          <div class="flex flex-row gap-(--gap-relaxed)">
            <ces-button pTooltip="test" label="Ajouter" (onClick)="log('Ajouter')" icon="add" />
            <ces-button-secondary label="Secondary" (onClick)="log('Secondary')" icon="add" />
            <ces-button-tertiary label="tertiary" (onClick)="log('tertiary')" icon="add" />
            <ces-button-tertiary-white label="tertiary white" (onClick)="log('tertiary white')" icon="add" />
          </div>
          <div class="flex flex-row gap-(--gap-relaxed)">
            <ces-button label="Ajouter" (onClick)="log('Ajouter')" size="small" icon="add" />
            <ces-button-secondary label="Secondary" (onClick)="log('Secondary')" size="small" icon="add" />
            <ces-button-tertiary label="tertiary" (onClick)="log('tertiary')" size="small" icon="add" />
            <ces-button-tertiary-white label="tertiary white" (onClick)="log('tertiary white')" size="small" icon="add" />
          </div>
          <h3 class="text-white">Right icons</h3>
          <div class="flex flex-row gap-(--gap-relaxed)">
            <ces-button pTooltip="test" label="Ajouter" (onClick)="log('Ajouter')" icon="add" iconPosition="right" />
            <ces-button-secondary label="Secondary" (onClick)="log('Secondary')" icon="add" iconPosition="right" />
            <ces-button-tertiary label="tertiary" (onClick)="log('tertiary')" icon="add" iconPosition="right" />
            <ces-button-tertiary-white label="tertiary white" (onClick)="log('tertiary white')" icon="add" iconPosition="right" />
          </div>
          <div class="flex flex-row gap-(--gap-relaxed)">
            <ces-button label="Ajouter" (onClick)="log('Ajouter')" size="small" icon="add" iconPosition="right" />
            <ces-button-secondary label="Secondary" (onClick)="log('Secondary')" size="small" icon="add" iconPosition="right" />
            <ces-button-tertiary label="tertiary" (onClick)="log('tertiary')" size="small" icon="add" iconPosition="right" />
            <ces-button-tertiary-white
              label="tertiary white"
              (onClick)="log('tertiary white')"
              size="small"
              icon="add"
              iconPosition="right" />
          </div>
        </div>
        <h2>Icons only</h2>
        <div
          class="flex flex-col gap-(--gap-relaxed) bg-(--surface-2) p-(--padding-card) border-3 border-violet-600 border-dashed rounded-(--radius-md)">
          <div class="flex flex-row gap-(--gap-normal)">
            <ces-button (onClick)="log('Primary')" icon="add" />
            <ces-button-secondary (onClick)="log('Secondary')" icon="add" />
          </div>
          <div class="flex flex-row gap-(--gap-normal)">
            <ces-button (onClick)="log('Primary')" size="small" icon="add" />
            <ces-button-secondary (onClick)="log('Secondary')" size="small" icon="add" />
          </div>
        </div>
        <h2>Confirmation button</h2>
        <div
          class="flex flex-col gap-(--gap-relaxed) bg-(--surface-2) p-(--padding-card) border-3 border-violet-600 border-dashed rounded-(--radius-md)">
          <div class="flex flex-row gap-(--gap-normal)">
            <ces-confirmation-button (onClick)="log('onClick')" (confirm)="log('confirm')" (cancel)="log('cancel')" icon="save" />
            <ces-confirmation-button (confirm)="log('confirm')" (cancel)="log('cancel')" icon="save" label="Confirm ?" />
          </div>
          <div class="flex flex-row gap-(--gap-normal)">
            <ces-confirmation-button (confirm)="log('confirm')" (cancel)="log('cancel')" icon="save" size="small" />
            <ces-confirmation-button (confirm)="log('confirm')" (cancel)="log('cancel')" icon="save" size="small" label="Confirm ?" />
          </div>
        </div>
        <h2>Delete buttons</h2>
        <div class="flex flex-col gap-(--gap-relaxed)">
          <div class="flex flex-row gap-(--gap-normal)">
            <ces-delete-button
              pTooltip="test"
              tooltipPosition="bottom"
              label="Delete"
              (confirm)="log('confirm')"
              (cancel)="log('cancel')" />
            <ces-delete-button label="Delete" size="small" (confirm)="log('confirm')" (cancel)="log('cancel')" />
            <ces-delete-button label="Delete" size="small" (onClick)="log('onClick')" />
          </div>
          <div class="flex flex-row gap-(--gap-normal)">
            <ces-delete-button [confirmationConfig]="{}" (confirm)="log('confirm')" (cancel)="log('cancel')" />
            <ces-delete-button size="small" (confirm)="log('confirm')" (cancel)="log('cancel')" />
            <ces-delete-button size="small" (onClick)="log('onClick')" />
          </div>
          <h2>Sidebar buttons</h2>
          <div
            class="flex flex-row gap-(--gap-relaxed) bg-(--surface-2) p-(--padding-card) border-3 border-violet-600 border-dashed rounded-(--radius-md)">
            <ces-sidebar-button icon="right_panel_close" (onClick)="log('sidebar')" />
            <ces-sidebar-button icon="left_panel_close" (onClick)="log('sidebar')" />
          </div>
        </div>
        <hr />
        <h2>Toolbar buttons</h2>

        <div
          class="flex flex-row gap-(--gap-relaxed) bg-(--surface-2) p-(--padding-card) border-3 border-violet-600 border-dashed rounded-(--radius-md)">
          <ces-toolbar-button label="Toolbar" (onClick)="log('Toolbar')" />
          <ces-toolbar-button label="Toolbar" (onClick)="log('Toolbar')" />
          <ces-toolbar-button label="Toolbar" (onClick)="log('Toolbar')" />
        </div>
        <h2>Sidebar navigation buttons</h2>

        <div
          class="flex flex-row gap-(--gap-relaxed) bg-(--surface-2) p-(--padding-card) border-3 border-violet-600 border-dashed rounded-(--radius-md)">
          <ces-nav-item-button label="Navigation" (onClick)="log('Navigation')" />
        </div>
        <div class="flex flex-row gap-(--gap-relaxed)"></div>
        <div class="flex flex-row gap-(--gap-relaxed)"></div>
        <div class="flex flex-row gap-(--gap-relaxed)"></div>
      </div>
      <div class="flex items-start justify-start flex-col min-h-screen w-full gap-(--gap-relaxed)">
        <p-card header="Boutons standard">
          <div class="w-full flex flex-row gap-(--gap-relaxed) flex-wrap">
            <p-card subheader="Primaires">
              <div class="flex flex-col gap-(--gap-normal)">
                <p-card subheader="Grands">
                  <div class="flex flex-row gap-(--gap-normal) justify-start items-center">
                    <ces-button label="Ajouter" />
                    <ces-button icon="add" label="Ajouter" />
                    <ces-button icon="add" />
                    <ces-button icon="settings" />
                  </div>
                </p-card>
                <p-card subheader="Petits">
                  <div class="flex flex-row gap-(--gap-normal) justify-start items-center">
                    <ces-button size="small" label="Ajouter" />
                    <ces-button size="small" icon="add" label="Ajouter" />
                    <ces-button size="small" icon="add" />
                    <ces-button size="small" icon="settings" />
                  </div>
                </p-card>
              </div>
            </p-card>
            <p-card subheader="Secondaires">
              <div class="flex flex-col gap-(--gap-normal)">
                <p-card subheader="Grands">
                  <div class="flex flex-row gap-(--gap-normal) justify-start items-center">
                    <ces-button-secondary label="Documents" />
                    <ces-button-secondary icon="add" label="Documents" />
                    <ces-button-secondary icon="add" />
                    <ces-button-secondary icon="settings" />
                  </div>
                </p-card>
                <p-card subheader="Petits">
                  <div class="flex flex-row gap-(--gap-normal) justify-start items-center">
                    <ces-button-secondary size="small" label="Documents" />
                    <ces-button-secondary size="small" icon="add" label="Documents" />
                    <ces-button-secondary size="small" icon="add" label="Documents" iconPosition="right" />
                    <ces-button-secondary size="small" icon="add" />
                    <ces-button-secondary size="small" icon="settings" />
                  </div>
                </p-card>
              </div>
            </p-card>
            <p-card subheader="Tertiaires (text + primary)">
              <p-card subheader="Grands">
                <div class="flex flex-row gap-(--gap-normal) justify-start items-center bg-neutral-200 p-(--padding-card)">
                  <ces-button-tertiary label="Documents" />
                  <ces-button-tertiary icon="add" label="Documents" />
                  <ces-button-tertiary icon="add" />
                </div>
              </p-card>
              <p-card subheader="Petits">
                <div class="flex flex-row gap-(--gap-normal) justify-start items-center bg-neutral-200 p-(--padding-card)">
                  <ces-button-tertiary size="small" label="Documents" />
                  <ces-button-tertiary size="small" icon="add" label="Documents" />
                  <ces-button-tertiary size="small" icon="add" />
                </div>
              </p-card>
            </p-card>
            <p-card subheader="Tertiaires blancs (text + secondary)">
              <p-card subheader="Grands">
                <div class="flex flex-row gap-(--gap-normal) justify-start items-center bg-neutral-200 p-(--padding-card)">
                  <ces-button-tertiary-white label="Documents" />
                  <ces-button-tertiary-white icon="add" label="Documents" />
                  <ces-button-tertiary-white icon="add" />
                </div>
              </p-card>
              <p-card subheader="Petits">
                <div class="flex flex-row gap-(--gap-normal) justify-start items-center bg-neutral-200 p-(--padding-card)">
                  <ces-button-tertiary-white size="small" label="Documents" />
                  <ces-button-tertiary-white size="small" icon="add" label="Documents" />
                  <ces-button-tertiary-white size="small" icon="add" />
                </div>
              </p-card>
            </p-card>
          </div>
        </p-card>

        <p-card header="États des boutons">
          <div class="w-full flex flex-row flex-wrap gap-(--gap-relaxed)">
            <p-card subheader="Boutons désactivés (disabled)">
              <div class="flex flex-col flex-wrap gap-(--gap-relaxed)">
                <div class="flex flex-row gap-(--gap-normal) flex-wrap justify-start items-center">
                  <ces-button label="Primaire désactivé" [disabled]="true" />
                  <ces-button-secondary label="Secondaire désactivé" [disabled]="true" />
                  <ces-button-tertiary label="Tertiaire désactivé" [disabled]="true" />
                  <ces-delete-button label="Supprimer désactivé" [disabled]="true" />
                </div>
                <div class="flex flex-row gap-(--gap-normal) flex-wrap justify-start items-center">
                  <ces-button icon="add" label="Avec icône désactivé" [disabled]="true" />
                  <ces-button icon="add" [disabled]="true" />
                  <ces-button variant="tabButton" label="Tab désactivé" [disabled]="true" />
                  <ces-button variant="statusButton" label="Status désactivé" [disabled]="true" />
                </div>
              </div>
            </p-card>

            <p-card subheader="Boutons en chargement (loading)">
              <div class="flex flex-col gap-(--gap-relaxed)">
                <div class="flex flex-row gap-(--gap-normal) justify-start items-center">
                  <ces-button label="Chargement..." [loading]="true" />
                  <ces-button-secondary label="Chargement..." [loading]="true" />
                  <ces-button-tertiary label="Chargement..." [loading]="true" />
                  <ces-button [loading]="true" />
                </div>
              </div>
            </p-card>
          </div>
        </p-card>

        <p-card header="Variants personnalisés">
          <div class="w-full flex flex-row flex-wrap gap-(--gap-relaxed)">
            <p-card subheader="Sidebar">
              <div class="flex flex-row gap-(--gap-relaxed)">
                <ces-sidebar-button size="small" icon="left_panel_close" />
                <ces-sidebar-button size="small" icon="right_panel_close" />
                <ces-sidebar-button size="small" icon="menu_open" />
              </div>
            </p-card>

            <p-card subheader="Navigation">
              <div class="flex flex-row gap-(--gap-normal) justify-start items-center bg-neutral-400 p-(--padding-card)">
                <ces-button icon="dashboard" label="Dashboard" variant="navItem" />
                <ces-button icon="person" label="Profile" variant="navItem" />
                <ces-button icon="settings" label="Settings" variant="navItem" />
              </div>
            </p-card>
          </div>
        </p-card>

        <p-card header="Nouveaux variants">
          <div class="w-full flex flex-row flex-wrap gap-(--gap-relaxed)">
            <p-card subheader="Status Button">
              <div class="flex flex-row gap-(--gap-relaxed)">
                <ces-button variant="statusButton" severity="success" label="Actif" />
                <ces-button variant="statusButton" severity="warn" label="En attente" />
                <ces-button variant="statusButton" severity="danger" label="Erreur" />
              </div>
            </p-card>

            <p-card subheader="Pure Link Button">
              <div class="flex flex-row gap-(--gap-relaxed)">
                <ces-button variant="pureLinkButton" label="Voir détails" />
                <ces-button variant="pureLinkButton" icon="open_in_new" label="Ouvrir dans un nouvel onglet" />
              </div>
            </p-card>

            <p-card subheader="Tab Button">
              <div class="flex flex-row gap-(--gap-relaxed) border-b border-(--border)">
                <ces-button variant="tabButton" [config]="{ active: true }" label="Onglet 1" />
                <ces-button variant="tabButton" label="Onglet 2" />
                <ces-button variant="tabButton" label="Onglet 3" />
              </div>
              <div class="p-(--padding-card)">Contenu de l'onglet 1</div>
            </p-card>
          </div>
        </p-card>

        <p-card header="Toolbar Button">
          <div class="w-full flex flex-row flex-wrap gap-(--gap-relaxed)">
            <p-card subheader="Basic Toolbar Buttons">
              <div class="flex flex-row gap-(--gap-relaxed) bg-(--surface-2) p-(--padding-card)">
                <ces-button variant="toolbarButton" label="Paramétrage" icon="settings" />
                <ces-button variant="toolbarButton" [config]="{ active: true }" label="Dashboard" icon="dashboard" />
                <ces-button variant="toolbarButton" label="Profile" icon="person" />
              </div>
            </p-card>

            <p-card subheader="Toolbar avec Avatar (Initiales)">
              <div class="flex flex-row gap-(--gap-relaxed) bg-(--surface-2) p-(--padding-card)">
                <ces-button variant="toolbarButton" label="John Doe" icon="JD" [config]="{ isInitials: true }" />
                <ces-button variant="toolbarButton" label="Admin" icon="A" [config]="{ isInitials: true, active: true }" />
              </div>
            </p-card>

            <p-card subheader="Toolbar avec Menu">
              <div class="flex flex-row gap-(--gap-relaxed) bg-(--surface-2) p-(--padding-card)">
                <ces-toolbar-button variant="toolbarButton" label="Menu utilisateur" icon="JD" [items]="userMenuItems">
                  <ng-template #menuItemTemplate let-item>
                    <div class="p-menuitem-link flex items-center gap-(--gap-normal) p-(--space-2)">
                      @if (item.icon) {
                        <span class="material-symbols">
                          {{ item.icon }}
                        </span>
                      }
                      <span>{{ item.label }}</span>
                    </div>
                  </ng-template></ces-toolbar-button
                >
                <ces-toolbar-button label="Paramètres" icon="settings" [items]="settingsMenuItems" />
              </div>
            </p-card>
          </div>
        </p-card>

        <p-card header="Delete Button">
          <div class="w-full flex flex-row flex-wrap gap-(--gap-relaxed)">
            <p-card subheader="Boutons standard">
              <div class="flex flex-row gap-(--gap-relaxed)">
                <ces-delete-button label="Supprimer" (confirm)="handleDeleteConfirm('item')" />

                <ces-delete-button
                  icon="delete_forever"
                  label="Supprimer définitivement"
                  [confirmationConfig]="{
                    message: 'Attention : cette action est irréversible. Êtes-vous sûr ?',
                  }"
                  (confirm)="handleDeleteConfirm('permanent')" />

                <ces-delete-button icon="delete" (confirm)="handleDeleteConfirm('icon-only')" />
              </div>
            </p-card>

            <p-card subheader="Variations">
              <div class="flex flex-row gap-(--gap-relaxed)">
                <ces-delete-button size="small" (confirm)="handleDeleteConfirm('small')" />

                <ces-delete-button size="small" label="Version petite" (confirm)="handleDeleteConfirm('small')" />

                <ces-delete-button label="Version texte" [config]="{ text: true }" (confirm)="handleDeleteConfirm('text')" />
              </div>
            </p-card>
          </div> </p-card
        ><p-card header="Formulaires">
          <div class="w-full flex flex-row flex-wrap gap-(--gap-relaxed)">
            <p-card subheader="Gestion asset">
              <app-asset-form [entityDefinition]="assetConfig" [additionalData]="{ assetTypes: assetTypeStore.entities() }" />
            </p-card>

            <p-card subheader="Gestion asset group">
              <app-asset-group-form [entityDefinition]="assetGroupConfig" [additionalData]="{}" />
            </p-card>
          </div>
        </p-card>
      </div>
    </div>
  </div>
</div>
